import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility for merging tailwind classes properly
 */
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const Input = React.forwardRef(({ 
  className, 
  error, 
  label, 
  hint, 
  icon: Icon,
  type = 'text', 
  ...props 
}, ref) => {
  return (
    <div className="space-y-2 w-full group">
       {label && (
         <label
           className="text-[11px] font-semibold transition-colors"
           style={{
             color: error ? '#BA0517' : 'var(--color-text-main)'
           }}
         >
           {label}
         </label>
       )}

       <div className="relative">
          {Icon && (
            <div
              className="absolute left-3 top-1/2 -translate-y-1/2 transition-colors"
              style={{
                color: error ? '#BA0517' : 'var(--color-text-dim)'
              }}
            >
               <Icon size={18} />
            </div>
          )}

          <input
            ref={ref}
            type={type}
            className={cn(
              "w-full h-9 rounded-[var(--radius-slds)] px-3 text-[13px] font-normal outline-none transition-all duration-150",
              Icon && "pl-10",
              className
            )}
            style={{
              backgroundColor: 'var(--color-brand-card)',
              borderColor: error ? 'var(--slds-color-error)' : '#D8DDE6',
              color: 'var(--color-text-main)',
              borderWidth: '1px',
              borderStyle: 'solid',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#0176D3';
              e.target.style.boxShadow = '0 0 0 3px rgba(1, 118, 211, 0.08)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = error ? '#BA0517' : '#D8DDE6';
              e.target.style.boxShadow = error ? 'inset 0 0 0 3px rgba(186, 5, 23, 0.08)' : 'none';
            }}
            {...props}
          />
       </div>

       {error && (
         <div className="text-[11px] font-medium ml-0.5 animate-in slide-in-from-top-1" style={{ color: '#BA0517' }}>
            {error}
         </div>
       )}
       {hint && !error && (
         <div className="text-[11px] font-medium ml-0.5" style={{ color: 'var(--color-text-muted)' }}>
            {hint}
         </div>
       )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;

export { Input };
